// gatsby-browser.js
import "./src/styles/global.css"
import React from 'react'
import { ThemeProvider } from './src/context/ThemeContext'

// Wrap with theme provider
export const wrapRootElement = ({ element }) => {
  return <ThemeProvider>{element}</ThemeProvider>
}

// Theme initialization script
const script = function() {
  function getInitialTheme() {
    try {
      const persistedTheme = localStorage.getItem('theme')
      if (persistedTheme) return persistedTheme
      
      const systemPrefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
      return systemPrefersDark ? 'dark' : 'light'
    } catch (err) {
      return 'light'
    }
  }
  
  const theme = getInitialTheme()
  document.documentElement.classList.add(theme)
}

export const onClientEntry = () => {
  script()
}